const deliveryPeriods = [
    { key: "Immediate", value: "Immediate" },
    { key: "Within the next 3 months", value: "Within the next 3 months" },
    { key: "Within 3-6 months", value: "Within 3-6 months" },
    { key: "After 6 months", value: "After 6 months" },
];

export { deliveryPeriods };